export default "__VITE_ASSET__9729826a__"